import {ModuleComponent} from "../../js/module-component";
import Swiper from "swiper/bundle";

// import Swiper and modules styles
export class ModFeatures extends ModuleComponent{
    ready(){
        super.ready();
        this.withoutAutoplay = this.$root.data(`without-autoplay`);
        const swiperContainer = this.$root.find(`.swiper-container`).get(0);

        if(!swiperContainer) return;

        this.swiper = new Swiper(swiperContainer,{
            direction: `horizontal`,
            pagination: {
                el: this.$root.find(`.swiper-pagination`).get(0),
                pauseOnMouseEnter: true
            },
            paginationType: `bullets`,
            navigation: {
                nextEl: this.$root.find(`.swiper-button-next`).get(0),
                prevEl: this.$root.find(`.swiper-button-prev`).get(0)
            },
            autoplay: {
                delay: 5000,
            },
            speed: 800,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            initialSlide: 0,
        });


        // detener al pasar el ratón
        this.findMember("swiper").on('mouseover', () => {
            console.log("O");
            this.swiper.autoplay.stop();
        });

        this.findMember("swiper").on('mouseleave', () => {
            console.log("L");
            // this.swiper.setTransition(this.swiper.params.speed);
            this.swiper.autoplay.start();
        });


    }
}
